<template>
  <DashboardPageLayout
    title="Customers"
    :is-loading="isLoading"
    @change="onDateRangeChange"
  >
    <template #summary>
      <div class="text-muted small">
        {{ formattedDateRange }}
      </div>
      <div
        v-if="customersByDay"
        class="font-weight-bold"
        :style="{ color: customersColor }"
      >
        Total created customers: {{ $formatNumber(customersByDay.total, 0) }}
      </div>
    </template>

    <template #default="{ isLoading: chartLoading }">
      <DashboardChartCard
        title="New customers by date"
        type="bar"
        :is-loading="chartLoading"
        :has-data="chartHasData"
        empty-text="No customers created in the selected date range."
        :options="chartOptions"
        :series="chartSeries"
      />
    </template>
  </DashboardPageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DashboardPageLayout from '@/views/Components/Elements/DashboardPageLayout.vue'
import DashboardChartCard from '@/views/Components/Elements/DashboardChartCard.vue'
import dashboardPageMixin from '@/mixins/dashboardPageMixin'
import {
  buildDashboardChartOptions,
  buildDashboardChartViewFromStatistics,
} from '@/libs/dashboardChart'

const CUSTOMERS_COLOR = '#4F439E'

export default {
  components: {
    DashboardPageLayout,
    DashboardChartCard,
  },
  mixins: [dashboardPageMixin],
  data() {
    return {
      dashboardLoadErrorMessage: 'Can not load customers statistics',
      customersColor: CUSTOMERS_COLOR,
    }
  },
  computed: {
    ...mapGetters({
      customersByDay: 'dashboard/customersByDay',
    }),
    chartHasData() {
      return (this.customersByDay?.days || []).length > 0
    },
    chartView() {
      return buildDashboardChartViewFromStatistics({
        statistics: this.customersByDay,
        selectedDateRange: this.selectedDateRange,
        series: [{ name: 'New customers', key: 'count' }],
      })
    },
    chartSeries() {
      return this.chartView?.series || []
    },
    chartOptions() {
      return buildDashboardChartOptions({
        chartView: this.chartView,
        chartType: 'bar',
        colors: [this.customersColor],
        yAxisTitle: 'Customers',
        yAxisFormatter: (value) => Math.round(value).toLocaleString(this.$getNumberLocale()),
      })
    },
  },
  methods: {
    ...mapActions({
      loadCustomersByDay: 'dashboard/loadCustomersByDay',
    }),
    fetchDashboardData(payload) {
      return this.loadCustomersByDay(payload)
    },
  },
}
</script>
